import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function doesCseApplyToProposition(enrollmentId: number, propositionId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.doesCseApplyToProposition.url, {
        id: enrollmentId,
        propositionId
      })
    )
    .get<boolean>()
}
